import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material"; // Assuming Material-UI is used

const RichContentList = ({
  content,
  index,
  scrollToBottom,
  textColor = "black",
}) => {
  useEffect(() => {
    if (scrollToBottom) {
      scrollToBottom();
    }
  }, []);

  return (
    <Box
      key={index}
      sx={{
        width: "100%",
        marginBottom: "0%",
        marginTop: "10px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Google Sans",
          fontWeight: "bold",
          fontSize: "24px",
          color: textColor,
        }}
      >
        {content.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Google Sans",
          fontSize: "20px",
          color: textColor,
        }}
      >
        {content.subtitle}
      </Typography>
      <ul>
        {content.options?.map((lineItem, index) => (
          <Box
            component="li"
            key={index}
            sx={{ margin: "8px 0", color: textColor }}
          >
            {lineItem.text}
          </Box>
        ))}
      </ul>
    </Box>
  );
};

export default RichContentList;

// Usage example:
/*
<RichContentList
  index={0}
  content={{
    type: 'richContent',
    content: {
      type: 'list',
      title: 'List Title',
      subtitle: 'List Subtitle',
      options: [
        { text: 'Item 1' },
        { text: 'Item 2' },
        { text: 'Item 3' }
      ]
    }
  }}
/>
*/
